<ng-container *ngIf="!loadingFlatsInfo">
  <div class="toogle-tables" *ngIf="firstFlat.totalFlatCount > 0">
    <table>
      <thead>
        <tr>
          <th colspan="1"></th>
          <th colspan="2" class="gray">Всего</th>
          <th colspan="3">Реализовано</th>
          <th colspan="2" class="gray">Остаток</th>
          <th colspan="1">Доход от продажи</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Квартиры</td>
          <td class="gray">Ед.</td>
          <td class="gray">Себеcтоимость</td>
          <td>Ед.</td>
          <td>Себеcтоимость</td>
          <td>Фактическая стоимость реализации</td>
          <td class="gray">Ед.</td>
          <td class="gray">Себестоимость</td>
          <td></td>
        </tr>
        <tr *ngFor="let flat of itemsForFlatsEx;">
          <td >{{flat.roomCountTitle}}</td>
          <td class="gray">{{flat.totalFlatCount | numberWithSpaces}}</td>
          <td class="gray">{{flat.totalFlatAmount}}</td>
          <td>{{flat.salesFlatCount | numberWithSpaces}}</td>
          <td>{{flat.salesFlatAmount1 | numberWithSpaces}}</td>
          <td>{{flat.salesFlatAmount2 | numberWithSpaces}}</td>
          <td class="gray">{{flat.residueFlatCount | numberWithSpaces}}</td>
          <td class="gray">{{flat.residueFlatAmount | numberWithSpaces}}</td>
          <td>{{flat.income | numberWithSpaces}}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr *ngIf="firstFlat.totalFlatCount > 0">
          <td>{{firstFlat.roomCountTitle}}</td>
          <td class="gray">{{firstFlat.totalFlatCount | numberWithSpaces}}</td>
          <td class="gray">{{firstFlat.totalFlatAmount}}</td>
          <td>{{firstFlat.salesFlatCount | numberWithSpaces}}</td>
          <td>{{firstFlat.salesFlatAmount1 | numberWithSpaces}}</td>
          <td>{{firstFlat.salesFlatAmount2 | numberWithSpaces}}</td>
          <td class="gray">{{firstFlat.residueFlatCount | numberWithSpaces}}</td>
          <td class="gray">{{firstFlat.residueFlatAmount | numberWithSpaces}}</td>
          <td>{{firstFlat.income | numberWithSpaces}}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</ng-container>
<app-flats [buildingId]="spotId" (confirmEvent)="reloadData($event)"></app-flats>
